import type { ICancellationPositionPayment, ICancellationView } from "@/data/model/Cancellation";
import { PaymentState } from "@/data/model/Enums";
import type { IPayment, IPaymentMethodSplit } from "@/data/model/Order";
import { Format } from "@/data/util/Format";

import type { PaymentMethodCell } from "@/operator/controller/PaymentsController";

export class PaymentMethodUtil {
    public static generatePaymentMethodDivIcon(unknownText: string, transaction: IPayment): string {
        if (transaction.brand != null && transaction.ccDigits != null) {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${Format.cardIconByBrand(transaction.brand)}');"></span> •••• ${transaction.ccDigits}${transaction.region !== undefined ? " / " + transaction.region : ""}</div>`;
        } else if (transaction.actualPaymentMethodImagePath != null && transaction.actualPaymentMethodImagePath != "") {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.actualPaymentMethodImagePath}');"></span></div>`;
        } else if (
            transaction.provider == null &&
            transaction.predefinedPaymentMethodImagePath != null &&
            transaction.predefinedPaymentMethodImagePath != ""
        ) {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.predefinedPaymentMethodImagePath}');"></span></div>`;
        }

        // We want to use a fallback for online payment only when they are confirmed
        if (transaction.state == PaymentState.Confirmed) {
            if (transaction.customPaymentMethodImagePath != null && transaction.customPaymentMethodImagePath != "") {
                return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.customPaymentMethodImagePath}');"></span></div>`;
            }

            if (
                transaction.predefinedPaymentMethodImagePath != null &&
                transaction.predefinedPaymentMethodImagePath != ""
            ) {
                return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.predefinedPaymentMethodImagePath}');"></span></div>`;
            }
        }

        return '<div class="ccinfo">' + unknownText + "</div>";
    }

    public static generatePaymentMethodSplitDivs(unknownText: string, transactions: IPaymentMethodSplit[]): string[] {
        const container = new Array<string>();
        let voucherIconAppended = false;

        for (const transaction of transactions) {
            if (transaction.code === "Voucher") {
                if (voucherIconAppended) {
                    continue;
                } else {
                    voucherIconAppended = true;
                }
            }

            if (transaction.brand != null && transaction.ccDigits != null) {
                container.push(
                    `<div class="ccinfo"><span class="brandicon" style="background-image:url('${Format.cardIconByBrand(transaction.brand)}');"></span> •••• ${transaction.ccDigits}${transaction.region !== undefined ? " / " + transaction.region : ""}</div>`
                );
            } else if (
                transaction.actualPaymentMethodImagePath != null &&
                transaction.actualPaymentMethodImagePath != ""
            ) {
                container.push(
                    `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.actualPaymentMethodImagePath}');"></span></div>`
                );
            } else if (
                transaction.provider == null &&
                transaction.predefinedPaymentMethodImagePath != null &&
                transaction.predefinedPaymentMethodImagePath != ""
            ) {
                container.push(
                    `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.predefinedPaymentMethodImagePath}');"></span></div>`
                );
            }
            // We want to use a fallback for online payment only when they are confirmed
            else if (transaction.state == PaymentState.Confirmed) {
                if (
                    transaction.customPaymentMethodImagePath != null &&
                    transaction.customPaymentMethodImagePath != ""
                ) {
                    container.push(
                        `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.customPaymentMethodImagePath}');"></span></div>`
                    );
                } else if (
                    transaction.predefinedPaymentMethodImagePath != null &&
                    transaction.predefinedPaymentMethodImagePath != ""
                ) {
                    container.push(
                        `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.predefinedPaymentMethodImagePath}');"></span></div>`
                    );
                }
            } else {
                container.push('<div class="ccinfo">' + unknownText + "</div>");
            }
        }

        return container;
    }

    public static generatePaymentMethodDivIconFromCancellationView(
        unknownText: string,
        transaction: ICancellationView
    ): string {
        if (transaction.brand != null && transaction.ccDigits != null) {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${Format.cardIconByBrand(transaction.brand)}');"></span> •••• ${transaction.ccDigits}${transaction.region !== undefined ? " / " + transaction.region : ""}</div>`;
        } else if (transaction.actualPaymentMethodImagePath != null && transaction.actualPaymentMethodImagePath != "") {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.actualPaymentMethodImagePath}');"></span></div>`;
        } else if (
            transaction.provider == null &&
            transaction.predefinedPaymentMethodImagePath != null &&
            transaction.predefinedPaymentMethodImagePath != ""
        ) {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.predefinedPaymentMethodImagePath}');"></span></div>`;
        } else if (transaction.customPaymentMethodImagePath != null && transaction.customPaymentMethodImagePath != "") {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.customPaymentMethodImagePath}');"></span></div>`;
        }

        return '<div class="ccinfo">' + unknownText + "</div>";
    }

    public static generatePaymentMethodDivIcon4(
        unknownText: string,
        transaction: ICancellationPositionPayment
    ): string {
        if (transaction.brand != null && transaction.ccDigits != null) {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${Format.cardIconByBrand(transaction.brand)}');"></span> •••• ${transaction.ccDigits}${transaction.region !== undefined ? " / " + transaction.region : ""}</div>`;
        } else if (transaction.actualPaymentMethodImagePath != null && transaction.actualPaymentMethodImagePath != "") {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.actualPaymentMethodImagePath}');"></span></div>`;
        } else if (
            transaction.provider == null &&
            transaction.predefinedPaymentMethodImagePath != null &&
            transaction.predefinedPaymentMethodImagePath != ""
        ) {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.predefinedPaymentMethodImagePath}');"></span></div>`;
        } else if (transaction.customPaymentMethodImagePath != null && transaction.customPaymentMethodImagePath != "") {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.customPaymentMethodImagePath}');"></span></div>`;
        }

        return '<div class="ccinfo">' + unknownText + "</div>";
    }

    public static generatePaymentMethodDivIcon5(unknownText: string, transaction: PaymentMethodCell): string {
        if (transaction.brand != null && transaction.ccDigits != null) {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${Format.cardIconByBrand(transaction.brand)}');"></span> •••• ${transaction.ccDigits}${transaction.region !== undefined ? " / " + transaction.region : ""}</div>`;
        } else if (transaction.actualPaymentMethodImagePath != null && transaction.actualPaymentMethodImagePath != "") {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.actualPaymentMethodImagePath}');"></span></div>`;
        } else if (
            transaction.provider == null &&
            transaction.predefinedPaymentMethodImagePath != null &&
            transaction.predefinedPaymentMethodImagePath != ""
        ) {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.predefinedPaymentMethodImagePath}');"></span></div>`;
        } else if (transaction.customPaymentMethodImagePath != null && transaction.customPaymentMethodImagePath != "") {
            return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.customPaymentMethodImagePath}');"></span></div>`;
        }

        // We want to use a fallback for online payment only when they are confirmed
        if (transaction.state == PaymentState.Confirmed) {
            if (
                transaction.predefinedPaymentMethodImagePath != null &&
                transaction.predefinedPaymentMethodImagePath != ""
            ) {
                return `<div class="ccinfo"><span class="brandicon" style="background-image:url('${transaction.predefinedPaymentMethodImagePath}');"></span></div>`;
            }
        }

        return '<div class="ccinfo">' + unknownText + "</div>";
    }
}
